import React from 'react'

export const LmsHome = [
  {
    name: 'Listagem de Aulas',
    component: React.lazy(() => import('../../modules/student/LMS/LecturesList')),
    path: '/student/blox/:bloxId',
    guards: ['allowOnlyStudents', 'allowOnlyLogged'],
  },
  {
    name: 'Visualização de Aula',
    component: React.lazy(() => import('../../modules/LMS/LectureView/index.js')),
    path: '/student/blox/:bloxId/lecture/:lectureId',
    guards: ['allowOnlyStudents', 'allowOnlyLogged'],
  },
]
